import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

/** Same inset row as Forum calendar events: off-white card, title, icon meta. */
export default function InsetItem({
  title,
  meta,
  action,
  className = '',
}: {
  title: ReactNode;
  meta?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={`p-3 bg-off-white rounded-lg ${className}`}>
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
        <div className="min-w-0 flex-1">
          <p className="font-medium text-navy break-words">{title}</p>
          {meta ? (
            <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-1 text-sm text-gray-600">
              {meta}
            </div>
          ) : null}
        </div>
        {action ? (
          <div className="flex items-center gap-1.5 flex-shrink-0 sm:justify-end">{action}</div>
        ) : null}
      </div>
    </div>
  );
}

export function InsetMeta({
  icon: Icon,
  children,
}: {
  icon?: LucideIcon;
  children: ReactNode;
}) {
  return (
    <span className="flex items-center gap-1">
      {Icon ? <Icon size={13} /> : null}
      {children}
    </span>
  );
}
